'use strict';

// Keep the same order as priceToggle

module.exports = {
  regular: 'regular',
  uom: 'uom',
  normWeight: 'normWeight',
};
